// extracted by mini-css-extract-plugin
module.exports = {"button":"layout-module--button--3EfsW","buttonDark":"layout-module--buttonDark--1kka9"};